import React from 'react';
import { motion } from 'framer-motion';
import './AboutPage.css';
import { FaBullseye, FaEye, FaUsers, FaLaptopCode, FaChalkboardTeacher, FaAward } from 'react-icons/fa';

import missionImage from '../assets/about/our_mission.png';
import visionImage from '../assets/about/our_vision.png';
import facultySponsorImage from '../assets/prof_rubana_khan.png';
import hodImage from '../assets/hod_image.jpg';

const AboutPage = () => {
    return (
        <motion.div 
            className="about-page"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
        >
            {/* Header Section */}
            <header className="about-header">
                <div className="about-header-content">
                    <h1>About PCE ACM Student Chapter</h1>
                    <p>Innovate. Create. Transform.</p>
                </div>
            </header>

            {/* Mission Section */}
            <section className="about-section mission-section">
                <motion.div 
                    className="about-card-image"
                    initial={{ opacity: 0, x: -100 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.8 }}
                >
                    <img src={missionImage} alt="Our Mission" />
                </motion.div>
                <motion.div 
                    className="about-card-text"
                    initial={{ opacity: 0, x: 100 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.8, delay: 0.2 }}
                >
                    <h2><FaBullseye /> Our Mission</h2>
                    <p>At ACM, our mission is to foster the open exchange of information and ideas in the computing world, supporting education, and promoting the highest professional standards.</p>
                    <blockquote className="quote">
                        "Empowering the next generation of computing professionals."
                    </blockquote>
                </motion.div>
            </section>

            {/* Vision Section */}
            <section className="about-section vision-section">
                <motion.div 
                    className="about-card-text"
                    initial={{ opacity: 0, x: -100 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.8 }}
                >
                    <h2><FaEye /> Our Vision</h2>
                    <p>We envision a world where computing helps solve the most challenging issues of humanity, transforming ideas into reality and making a difference in people's lives.</p>
                    <blockquote className="quote">
                        "Driving innovation and collaboration to build a better future."
                    </blockquote>
                </motion.div>
                <motion.div 
                    className="about-card-image"
                    initial={{ opacity: 0, x: 100 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.8, delay: 0.2 }}
                >
                    <img src={visionImage} alt="Our Vision" />
                </motion.div>
            </section>

            {/* Why Join Us Section */}
            <section className="why-join-us">
                <h2>Why Join Us?</h2>
                <div className="benefits-grid">
                    <motion.div className="benefit-card" whileHover={{ y: -10 }}>
                        <FaUsers className="benefit-icon" />
                        <h3>Networking</h3>
                        <p>Connect with peers, faculty, and industry professionals.</p>
                    </motion.div>
                    <motion.div className="benefit-card" whileHover={{ y: -10 }}>
                        <FaLaptopCode className="benefit-icon" />
                        <h3>Skill Development</h3>
                        <p>Participate in workshops on cutting-edge technologies.</p>
                    </motion.div>
                    <motion.div className="benefit-card" whileHover={{ y: -10 }}>
                        <FaChalkboardTeacher className="benefit-icon" />
                        <h3>Career Guidance</h3>
                        <p>Get access to seminars, resume workshops, and career advice.</p>
                    </motion.div>
                    <motion.div className="benefit-card" whileHover={{ y: -10 }}>
                        <FaAward className="benefit-icon" />
                        <h3>Competitions</h3>
                        <p>Showcase your skills in hackathons and coding contests.</p>
                    </motion.div>
                </div>
            </section>

            {/* Head of Department Section */}
            <section className="hod-section">
                <h2>Meet Our Head of Department</h2>
                <div className="sponsor-card">
                    <img src={hodImage} alt="Head of Department" className="sponsor-image" />
                    <h3>Dr. Archana. V. Dehankar</h3>
                    <p className="sponsor-title">Head of Department, Computer Technology</p>
                    <p className="sponsor-bio">
                        We are privileged to have the leadership and vision of our Head of Department, whose guidance is instrumental in fostering an environment of academic excellence and innovation.
                    </p>
                </div>
            </section>

            {/* Faculty Sponsor Section */}
            <section className="faculty-sponsor">
                <h2>Meet Our Faculty Sponsor</h2>
                <div className="sponsor-card">
                    <img src={facultySponsorImage} alt="Prof. Rubana Khan" className="sponsor-image" />
                    <h3>Prof. Rubana A. Khan</h3>
                    <p className="sponsor-title">Faculty Sponsor, PCE ACM Student Chapter</p>
                    <p className="sponsor-bio">
                        Our chapter thrives under the expert guidance of Prof. Rubana Khan. Her experience and unwavering support are a driving force behind our success and initiatives.
                    </p>
                </div>
            </section>
        </motion.div>
    );
};

export default AboutPage;
